// Passes vUv as screen-space coordinates, for sampling from full-screen buffers

varying vec2 vUv;

void main() {
    // vUv = uv;
    vUv = position.xy * 0.5 + 0.5;
    gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
}
